import React from 'react';
import {
  Button,
  Select,
  Space,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import SortListTemplateEditor from './SortListTemplateEditor';

type Props = {
  currentTemplate?: string;
  data: string;
  onChange?: Function;
};

const EditorWrapper = styled(Space)`
  width: 100%;

  & .ant-space-item:first-child {
    width: 100%;
  }
`;

const SortListTemplateSelector = (props: Props) => {
  const { useState } = React;
  const [currentSelected, setCurrentSelected] = useState<any>(props.currentTemplate);
  const [dataList, setDataList] = useState<StringKAnyVPair[]>([]);
  const [inited, setInited] = useState(false);
  const [templateEditorVisible, setTemplateEditorVisible] = useState(false);

  const closeTemplateEditor = () => {
    setTemplateEditorVisible(false);
  };

  const onSelect = (val: any) => {
    setCurrentSelected(val);
  };

  const openTemplateEditor = () => {
    setTemplateEditorVisible(true);
  };

  const saveSortList = (
    list: StringKAnyVPair[],
    currentValue: StringKAnyVPair,
  ) => {
    setDataList([...list]);

    if (props.onChange) props.onChange(currentSelected, currentValue);
  };

  React.useEffect(() => {
    if (!inited) {
      try {
        const options = JSON.parse(props.data);
        setDataList(options);
      } catch(e) {}
      setInited(true);
    }
  }, [inited, props]);

  return (<>
    <EditorWrapper>
      <Select
        onChange={onSelect}
        options={optionList(dataList)}
        value={currentSelected}
      />
      <Button
        disabled={!currentSelected}
        onClick={openTemplateEditor}
      >
        <EditOutlined />
        Edit
      </Button>
    </EditorWrapper>
    {templateEditorVisible && (
      <SortListTemplateEditor
        currentTemplate={currentSelected}
        onSavdTemplate={saveSortList}
        onClose={closeTemplateEditor}
        sortList={dataList}
        visible={templateEditorVisible}
      />
    )}
  </>);
};

export default SortListTemplateSelector;

export const optionList = (options: StringKAnyVPair[]) => {
  return options.map((e: any) => ({
    label: e.Name,
    value: e.Value,
  }));
};
